<template>
    <div :class="getCSSClass('repository-folder-picker-container')">
        <div :class="getCSSClass('repository-folder-picker-breadcrumbs-container')">
            <template v-for="node, nodeIndex in currentPath">
                <span :class="getCSSClass('repository-folder-picker-breadcrumb')"
                      v-on:click="selectNode(nodeIndex)"
                      v-html="node.name"></span>
                <span v-if="nodeIndex < currentPath.length - 1"
                      v-html="icon('breadcrumbSeparator')"
                        :class="getCSSClass('repository-folder-picker-breadcrumb-separator')"></span>

            </template>
        </div>
        <div v-if="loading" v-html="loadingIndicator"></div>
        <div v-else :class="getCSSClass('repository-folder-picker-folders-container')">
            <div v-if="currentPath.length > 1"
                 v-on:click="moveUpOneFolder"
                v-html="moveUpLabel"
                :class="getCSSClass('repository-folder-picker-move-up-row')"></div>
            <div v-if="sortedElements.folders.length == 0"
                 :class="getCSSClass('repository-folder-picker-no-folders-row')"
                 v-html="translate('Nincs megjeleníthető almappa')"></div>
            <template v-else>
                <div v-for="folder in sortedElements.folders"
                    :key="'folder-'+folder.id"
                    :class="getCSSClass('repository-folder-picker-item')"
                    v-on:click="selectFolder(folder)"
                     v-html="folder.name"
                ></div>
            </template>
        </div>
    </div>
</template>

<script>
    import {repositoryFolderFunctions} from "./mixins/repositoryFolderFunctions";
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
        mixins: [repositoryFolderFunctions],
        props: {},
        data: function () {
            return {
                loading: true,
            }
        },
        mounted() {
            this.currentPath = this.startingPath;
            this.initializePath();
            this.fetchElements();
        },
        methods: {
            selectFolder: function(folder) {
                this.setCurrentPathToFolder(folder);
            },
            fetchElements: function() {
                this.loading = true;
                window.axios.post(this.operationsUrl, {
                    operation: 'scanRepository',
                    repository: this.repositorySlug,
                    currentPath: this.currentPath,
                    viewMode: 'folder',
                }).then((response) => {
                    this.folders = response.data.folders;
                    this.loading = false;
                    if (this.currentPath[this.currentPath.length - 1]) {
                        this.$emit('input', this.currentPath[this.currentPath.length - 1].id);
                        this.$emit('files', response.data.files);
                        this.$emit('path', this.currentPath);
                    } else {
                        this.$emit('input', null);
                        this.$emit('files', []);
                        this.$emit('path', this.currentPath);
                    }
                })
            },
        },
        computed: {
        },
        watch: {}

    }
</script>
